module.exports = __webpack_public_path__ + "img/dingyue.2c28230b.png";